exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clear-date[data-v-3466af35]{position:absolute;top:2px;right:2px}", ""]);

// exports
